import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import PLANE from "../../../assets/images/plane.png";
import MALE_ICON from "../../../assets/images/user-male-circle.png";
import FEMALE_ICON from "../../../assets/images/user-female-circle.png";
import FLIGHT_SVG from "../../../assets/images/bannerflightgrey.svg";
import {
  getBookingDetails,
  getCreditNoteList,
  sendTicketEmailAndSMS,
} from "../services/mytrips.services";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../../components/spinner/Loading";
import { TfiArrowCircleDown } from "react-icons/tfi";
import BRIEFCASE from "../../../assets/images/briefcase.png";
import BACKPACK from "../../../assets/images/backpack.png";
import MICSVG from "../../../assets/images/megaphone-emoji.png";
import RIGHTWCIRCLE from "../../../assets/images/rightwithcircle.png";
import MAILICON from "../../../assets/images/mailforticketview.png";
import PHONEICON from "../../../assets/images/phoneforticketview.png";
import { BsFillTicketPerforatedFill } from "react-icons/bs";
import { API_URL } from "../../../app/config";
import { ErrorToast } from "../../../toast/Toasts";
import { HiDownload } from "react-icons/hi";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { BsFillFileTextFill } from "react-icons/bs";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaArrowRightArrowLeft, FaArrowRightLong } from "react-icons/fa6";
import { FaArrowLeft, FaEye } from "react-icons/fa";
import Modal from "../../../components/modal/Modal";
import { calculateFareDetailsFromReprint } from "../../../_helpers/fareUtils";
import { getRequestId } from "../../../_helpers/miscUtils";
import { getFlightImage } from "../../../_helpers/flightUtils";
import { formatIndianNumber } from "../../../_helpers/formatUtils";
import { FlightImage } from "../../../components/flightimage/FlightImage";

const CancelledTripDetails = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const loading = useAppSelector((state) => state?.mytrips?.loading);
  const location = useLocation();
  const [ticketLoading, setTicketLoading] = useState<any>(false);
  const [invoiceLoading, setInvoiceLoading] = useState<any>(false);
  const [activeFlightDetails, setactiveFlightDetails] = useState<number[]>([]);
  const [contactOpen, setContactOpen] = useState<boolean>(true);
  const [ticketLoadingIndexes, setTicketLoadingIndexes] = useState<number[]>(
    []
  );
  const [invoiceLoadingIndexes, setInvoiceLoadingIndexes] = useState<number[]>(
    []
  );
  const [CNLoadingIndexes, setCNLoadingIndexes] = useState<number[]>([]);
  const [isCNModalOpen, setIsCNModalOpen] = useState(false);

  const BookingDetails: any = useAppSelector(
    (state) => state?.mytrips?.BookinDetails
  );

  const CNLoading: any = useAppSelector((state) => state?.mytrips?.CNLoading);
  const CNList: any = useAppSelector((state) => state?.mytrips?.CNList);

  const emailLoading = useAppSelector((state) => state?.mytrips?.emailLoading);

  const isMultiPnr = BookingDetails?.AirPNRDetails?.length > 1;

  const closeBtnRef = useRef<any>(null);
  const openCNRef = useRef<any>(null);

  const formik = useFormik({
    initialValues: {
      email: "",
      mobile: "",
    },
    validationSchema: Yup.object()
      .shape({
        email: Yup.string().matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Invalid email format"
        ),
        mobile: Yup.string().matches(
          /^[0-9]{10}$/,
          "Mobile number must be 10 digits"
        ),
      })
      .test(
        "at-least-one-contact",
        "Either email or mobile number is required",
        function (values) {
          const { email, mobile } = values;
          if (!email && !mobile) {
            return this.createError({
              path: "email",
              message: "Either email or mobile number is required",
            });
          }
          return true;
        }
      ),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const payload = {
        email: values?.email ? values?.email : "",
        mobile: values?.mobile ? `${values?.mobile}` : "",
        Booking_RefNo: BookingDetails?.portal_booking_no,
        Airline_PNR: "",
      };
      const response = await dispatch(sendTicketEmailAndSMS(payload));
      if (response.meta.requestStatus === "fulfilled") {
        setSubmitting(false);
        resetForm();
        if (closeBtnRef.current) {
          closeBtnRef.current.click();
        }
      }
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const bookingId = params.get("bookingId");
    dispatch(
      getBookingDetails({
        Booking_RefNo: bookingId,
        Airline_PNR: "",
      })
    );
  }, []);

  const handleCreditNoteClick = async (BookingNo: string) => {
    try {
      const res = await dispatch(getCreditNoteList(BookingNo));
      if (res.meta.requestStatus === "fulfilled" && res.payload?.length > 0) {
        setIsCNModalOpen(true); // Open modal via state
      }
    } catch (error) {
      console.error("Error fetching credit notes:", error);
      ErrorToast("Failed to fetch Credit Note(s)! - Please try again later");
    }
  };

  const faredetails = calculateFareDetailsFromReprint(
    BookingDetails?.AirPNRDetails || []
  );

  const handleDownloadPdf = async (
    Booking_RefNo: string,
    Airline_PNR: string,
    index: number
  ) => {
    try {
      if (isMultiPnr) {
        setTicketLoadingIndexes((prev) => [...prev, index]);
      } else {
        setTicketLoading(true);
      }
      const Request_Id = getRequestId();

      const response = await fetch(
        `${API_URL}/AirlineReprint/Air_ReprintPDFCancel`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Booking_RefNo,
            Airline_PNR,
            IsPayment: false,
            Request_Id,
          }),
        }
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Cancelled-Ticket-${Airline_PNR}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Ticket! - Please try again later");
    } finally {
      if (isMultiPnr) {
        setTicketLoadingIndexes((prev) => prev.filter((i) => i !== index));
      } else {
        setTicketLoading(false);
      }
    }
  };

  const handleDownloadInvoice = async (
    Booking_RefNo: string,
    Airline_PNR: string,
    index: number
  ) => {
    try {
      if (isMultiPnr) {
        setInvoiceLoadingIndexes((prev) => [...prev, index]);
      } else {
        setInvoiceLoading(true);
      }

      const Request_Id = getRequestId();

      const response = await fetch(
        `${API_URL}/AirlineReprint/Air_ReprintInvoice`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Booking_RefNo,
            Airline_PNR,
            IsPayment: false,
            Request_Id,
          }),
        }
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `Cancelled-Invoice-${Airline_PNR}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Invoice! - Please try again later");
    } finally {
      if (isMultiPnr) {
        setInvoiceLoadingIndexes((prev) => prev.filter((i) => i !== index));
      } else {
        setInvoiceLoading(false);
      }
    }
  };

  const handleDownloadCN = async (
    Booking_RefNo: string,
    CreditNoteNo: string,
    index: number
  ) => {
    try {
      setCNLoadingIndexes((prev) => [...prev, index]);

      const response = await fetch(
        `${API_URL}/AirlineReprint/Air_ReprintCreditNote`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Booking_RefNo: Booking_RefNo,
            CreditNoteNo: CreditNoteNo,
            Airline_PNR: "",
            IsPayment: false,
            Request_Id: "REQ-mbbyv2qc-APJJK6JB",
          }),
        }
      );

      if (!response.ok) {
        ErrorToast("Failed to generate PDF! - Please try after some time");
        throw new Error(`Error: ${response.status} - ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `CreditNote-${Booking_RefNo}-${index}.pdf`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Credit Note! - Please try again later");
    } finally {
      setCNLoadingIndexes((prev) => prev.filter((i) => i !== index));
    }
  };

  return (
    <>
      <Loading loading={loading} backgroundColor="white" />
      {!loading && (
        <div className="trip-detail-page">
          <div className="ticket-header-wrapper">
            <div className="container ticket-header">
              <button
                onClick={() => navigate(-1)}
                className="btn btn-link me-3"
                style={{
                  width: "fit-content",
                  color: "rgb(0, 163, 77)",
                  background: "#ffffff",
                  padding: "8px",
                  borderRadius: "5px",
                }}
              >
                <FaArrowLeft size={20} />
              </button>
              <div className="row">
                <div className="col-lg-8 col-md-7 col-sm-12">
                  <h3>
                    Your Flight booking has{" "}
                    <span className="text-danger">Cancelled!</span>
                  </h3>
                  <div className="d-flex justify-content-between">
                    <div>
                      <span>Booking Ref. No. : </span>
                      <span className="fw-600">
                        {BookingDetails?.portal_booking_no}
                      </span>
                    </div>
                    <div>
                      <span>Booked On : </span>
                      <span className="fw-600">
                        {moment(
                          BookingDetails?.Booking_DateTime,
                          "DD/MM/YYYY HH:mm:ss"
                        ).format("DD/MM/YYYY | hh:mm:ss A")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="banner-flight-image">
                <img src={FLIGHT_SVG} alt="" />
              </div>
            </div>
          </div>
          <div className="container ticker-view-content">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12">
                {BookingDetails &&
                  BookingDetails?.AirPNRDetails?.filter((tripInfo: any) =>
                    tripInfo?.PAXTicketDetails?.some(
                      (e: any) =>
                        e?.TicketStatus === "Tocancel" ||
                        e?.TicketStatus === "Cancelled"
                    )
                  )?.map((tripInfo: any, tripIndex: any) => {
                    return (
                      <div className="ticket-flight-details">
                        <div
                          className="flight-details-header"
                          onClick={() => {
                            setactiveFlightDetails((prevFlightDetails) => {
                              if (prevFlightDetails.includes(tripIndex)) {
                                return prevFlightDetails.filter(
                                  (i) => i !== tripIndex
                                );
                              } else {
                                return [...prevFlightDetails, tripIndex];
                              }
                            });
                          }}
                        >
                          <h3 className="m-0">
                            {tripInfo?.Flights[0]?.Segments[0]?.Origin}{" "}
                            {BookingDetails?.Booking_Type === 2 ||
                            (BookingDetails?.Booking_Type === 1 &&
                              tripInfo?.Flights?.length === 2) ? (
                              <FaArrowRightArrowLeft />
                            ) : (
                              <FaArrowRightLong />
                            )}{" "}
                            {
                              tripInfo?.Flights[0]?.Segments[
                                tripInfo?.Flights[0]?.Segments?.length - 1
                              ]?.Destination
                            }
                          </h3>

                          <TfiArrowCircleDown
                            className="me-2 chevron-icon"
                            style={{
                              transform:
                                activeFlightDetails?.indexOf(tripIndex) >= 0
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                            }}
                          />
                        </div>
                        {activeFlightDetails?.indexOf(tripIndex) >= 0 && (
                          <div className="flight-details-content">
                            <>
                              {tripInfo?.Flights?.map(
                                (flight: any, tripIndex: number) => {
                                  const priceDetails =
                                    flight?.Fares && flight?.Fares[0];

                                  const cancellationCharges =
                                    (priceDetails?.FareDetails[0] &&
                                      priceDetails?.FareDetails[0]
                                        ?.CancellationCharges) ||
                                    [];
                                  const rescheduleCharges =
                                    (priceDetails?.FareDetails[0] &&
                                      priceDetails?.FareDetails[0]
                                        ?.RescheduleCharges) ||
                                    [];
                                  return (
                                    <div key={`flight_${tripIndex}`}>
                                      {flight?.Segments?.map(
                                        (segment: any, index: number) => {
                                          const {
                                            Flight_Number,
                                            Airline_Code,
                                            Departure_DateTime,
                                            Arrival_DateTime,
                                            Duration,
                                            Destination,
                                            Origin,
                                            Destination_Terminal,
                                            Origin_Terminal,
                                            Stop_Over,
                                            Airline_Name,
                                          } = segment;

                                          const adultCheckingBaggage =
                                            flight?.Fares?.[0]?.FareDetails?.[0]
                                              ?.Free_Baggage
                                              ?.Check_In_Baggage || "";
                                          const adultCabbinBaggage =
                                            flight?.Fares?.[0]?.FareDetails?.[0]
                                              ?.Free_Baggage?.Hand_Baggage ||
                                            "";
                                          const FlightClass =
                                            flight?.Fares?.[0]?.FareDetails?.[0]
                                              ?.FareClasses?.[index]
                                              ?.Class_Desc || "";

                                          return (
                                            <div
                                              key={`segment_${tripIndex}_${index}`}
                                            >
                                              <div className="flight-choose">
                                                <div className="fight-name">
                                                  <FlightImage
                                                    key={Airline_Code}
                                                    flightCode={Airline_Code}
                                                  />
                                                  <span>
                                                    <h5>{Airline_Name}</h5>
                                                    <p>
                                                      {Airline_Code} -{" "}
                                                      {Flight_Number}
                                                    </p>
                                                  </span>
                                                </div>
                                                <div className="route-timing">
                                                  <div className="route-strating">
                                                    <div className="ticket-view-time">
                                                      {moment(
                                                        Departure_DateTime
                                                      ).format("HH:mm")}
                                                      <span>
                                                        ,{" "}
                                                        {moment(
                                                          Departure_DateTime
                                                        ).format("ddd MMM D")}
                                                      </span>
                                                    </div>
                                                    <div className="ticket-view-place">
                                                      {Origin}
                                                    </div>
                                                    <p>
                                                      <span>
                                                        Terminal :{" "}
                                                        {Origin_Terminal}
                                                      </span>
                                                    </p>
                                                  </div>
                                                  <div className="cunsume-time">
                                                    <p>
                                                      {!Stop_Over ||
                                                      Stop_Over === 0
                                                        ? "Non Stop"
                                                        : `${Stop_Over} Stop`}
                                                    </p>
                                                    <div className="cunsume-pic">
                                                      <img src={PLANE} alt="" />
                                                    </div>
                                                    <strong>{Duration}</strong>
                                                  </div>
                                                  <div className="route-strating route-arrival">
                                                    <div className="ticket-view-time">
                                                      {moment(
                                                        Arrival_DateTime
                                                      ).format("HH:mm")}
                                                      <span>
                                                        ,{" "}
                                                        {moment(
                                                          Arrival_DateTime
                                                        ).format("ddd MMM D")}
                                                      </span>
                                                    </div>
                                                    <div className="ticket-view-place">
                                                      {Destination}
                                                    </div>
                                                    <p>
                                                      <span>
                                                        Terminal :{" "}
                                                        {Destination_Terminal}
                                                      </span>
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>

                                              <div className="route-bottom">
                                                <div className="fligt-parcel">
                                                  <div className="low-parcel w-50">
                                                    <BsFillTicketPerforatedFill
                                                      style={{
                                                        fontSize: 24,
                                                        color: "#00a34d",
                                                      }}
                                                    />
                                                    <span>
                                                      <strong>
                                                        {FlightClass}
                                                      </strong>
                                                    </span>
                                                  </div>
                                                  <div className="low-parcel w-50">
                                                    <FaEye
                                                      style={{
                                                        fontSize: 24,
                                                        color: "#00a34d",
                                                      }}
                                                      className="cursor-pointer"
                                                      data-bs-toggle="modal"
                                                      data-bs-target={`#farerulepopup_${tripIndex}_${index}`}
                                                    />
                                                    <span
                                                      className="cursor-pointer"
                                                      data-bs-toggle="modal"
                                                      data-bs-target={`#farerulepopup_${tripIndex}_${index}`}
                                                    >
                                                      <strong className="text-dark">
                                                        View Fare Rule
                                                      </strong>
                                                    </span>
                                                  </div>
                                                </div>
                                                <div className="fligt-parcel">
                                                  <div className="low-parcel w-50">
                                                    <img src={BRIEFCASE} />
                                                    <span>
                                                      <strong>
                                                        Cabin Baggage:{" "}
                                                      </strong>
                                                      {adultCabbinBaggage} /
                                                      Adult
                                                    </span>
                                                  </div>
                                                  <div className="low-parcel w-50">
                                                    <img src={BACKPACK} />
                                                    <span>
                                                      <strong>
                                                        Check-In Baggage:{" "}
                                                      </strong>
                                                      {adultCheckingBaggage} /
                                                      Adult
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div
                                                className="modal fade"
                                                id={`farerulepopup_${tripIndex}_${index}`}
                                                data-bs-backdrop="static"
                                                data-bs-keyboard="false"
                                                tabIndex={-1}
                                                aria-labelledby="farerulepopup"
                                                aria-hidden="true"
                                              >
                                                <div
                                                  className="modal-dialog modal-dialog-centered"
                                                  style={{ maxWidth: 991 }}
                                                >
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h4
                                                        className="modal-title fs-5"
                                                        id="edit-profile"
                                                      >
                                                        Fare Rule Information
                                                      </h4>
                                                      <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                      ></button>
                                                    </div>
                                                    <div className="modal-body travel-form-detail">
                                                      {cancellationCharges?.length <=
                                                        0 &&
                                                      rescheduleCharges?.length <=
                                                        0 ? (
                                                        <h4 className="text-center">
                                                          Non - Refundable!!!
                                                        </h4>
                                                      ) : (
                                                        <div
                                                          style={{
                                                            maxHeight:
                                                              "calc(100vh - 300px)",
                                                            overflowY: "auto",
                                                          }}
                                                        >
                                                          {cancellationCharges?.length >
                                                            0 && (
                                                            <div className="cancel-wrapper">
                                                              <div className="cancel-table-container">
                                                                <table className="cancel-table">
                                                                  <thead>
                                                                    <tr>
                                                                      <th
                                                                        colSpan={
                                                                          5
                                                                        }
                                                                        className="cancel-th"
                                                                      >
                                                                        <h4>
                                                                          Cancellation
                                                                          Charges
                                                                        </h4>
                                                                      </th>
                                                                    </tr>
                                                                    <tr>
                                                                      <th className="cancel-th">
                                                                        #
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Applicability
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Passenger
                                                                        Type
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Duration
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Charge
                                                                      </th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    {cancellationCharges?.map(
                                                                      (
                                                                        cCharge: any,
                                                                        index: number
                                                                      ) => {
                                                                        return (
                                                                          <tr className="cancel-row">
                                                                            <td className="cancel-td">
                                                                              {index +
                                                                                1}
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              <span className="cancel-pill">
                                                                                Per{" "}
                                                                                {cCharge?.Applicablility ===
                                                                                0
                                                                                  ? "Segment"
                                                                                  : "Passenger"}
                                                                              </span>
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              {cCharge?.PassengerType ===
                                                                              0
                                                                                ? "Adult"
                                                                                : cCharge?.PassengerType ===
                                                                                  1
                                                                                ? "Child"
                                                                                : "Infant"}
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              {
                                                                                cCharge?.DurationFrom
                                                                              }{" "}
                                                                              {cCharge?.DurationTypeFrom ===
                                                                              0
                                                                                ? "Hr(s) "
                                                                                : cCharge?.DurationTypeFrom ===
                                                                                  1
                                                                                ? "days "
                                                                                : ""}{" "}
                                                                              –{" "}
                                                                              {
                                                                                cCharge?.DurationTo
                                                                              }{" "}
                                                                              {cCharge?.DurationTypeTo ===
                                                                              0
                                                                                ? "Hr(s)"
                                                                                : cCharge?.DurationTypeTo ===
                                                                                  1
                                                                                ? "days"
                                                                                : ""}
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              {+cCharge?.Value ===
                                                                              0 ? (
                                                                                "Non Chargeable"
                                                                              ) : +cCharge?.Value ===
                                                                                  100 &&
                                                                                cCharge?.ValueType ===
                                                                                  1 ? (
                                                                                "Non Refundable"
                                                                              ) : (
                                                                                <>
                                                                                  {cCharge?.ValueType ===
                                                                                  0
                                                                                    ? "₹ "
                                                                                    : ""}
                                                                                  {
                                                                                    cCharge?.Value
                                                                                  }
                                                                                  {cCharge?.ValueType ===
                                                                                  1
                                                                                    ? "%"
                                                                                    : ""}
                                                                                </>
                                                                              )}
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      }
                                                                    )}
                                                                    <tr className="cancel-row">
                                                                      <td
                                                                        className="cancel-td"
                                                                        colSpan={
                                                                          5
                                                                        }
                                                                      >
                                                                        <strong className="d-block">
                                                                          *From
                                                                          the
                                                                          Time
                                                                          of
                                                                          Departure
                                                                        </strong>
                                                                        <strong>
                                                                          *Sevice
                                                                          charge
                                                                          will
                                                                          be
                                                                          extra
                                                                        </strong>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            </div>
                                                          )}
                                                          {rescheduleCharges?.length >
                                                            0 && (
                                                            <div className="cancel-wrapper">
                                                              <div className="cancel-table-container">
                                                                <table className="cancel-table">
                                                                  <thead>
                                                                    <tr>
                                                                      <th
                                                                        colSpan={
                                                                          5
                                                                        }
                                                                        className="cancel-th"
                                                                      >
                                                                        <h4>
                                                                          Reschedule
                                                                          Charges
                                                                        </h4>
                                                                      </th>
                                                                    </tr>
                                                                    <tr>
                                                                      <th className="cancel-th">
                                                                        #
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Applicability
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Passenger
                                                                        Type
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Duration
                                                                      </th>
                                                                      <th className="cancel-th">
                                                                        Charge
                                                                      </th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    {rescheduleCharges?.map(
                                                                      (
                                                                        rCharge: any,
                                                                        index: number
                                                                      ) => {
                                                                        return (
                                                                          <tr className="cancel-row">
                                                                            <td className="cancel-td">
                                                                              {index +
                                                                                1}
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              <span className="cancel-pill">
                                                                                Per{" "}
                                                                                {rCharge?.Applicablility ===
                                                                                0
                                                                                  ? "Segment"
                                                                                  : "Passenger"}
                                                                              </span>
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              {rCharge?.PassengerType ===
                                                                              0
                                                                                ? "Adult"
                                                                                : rCharge?.PassengerType ===
                                                                                  1
                                                                                ? "Child"
                                                                                : "Infant"}
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              {
                                                                                rCharge?.DurationFrom
                                                                              }{" "}
                                                                              {rCharge?.DurationTypeFrom ===
                                                                              0
                                                                                ? "Hr(s) "
                                                                                : rCharge?.DurationTypeFrom ===
                                                                                  1
                                                                                ? "days "
                                                                                : ""}{" "}
                                                                              –{" "}
                                                                              {
                                                                                rCharge?.DurationTo
                                                                              }{" "}
                                                                              {rCharge?.DurationTypeTo ===
                                                                              0
                                                                                ? "Hr(s)"
                                                                                : rCharge?.DurationTypeTo ===
                                                                                  1
                                                                                ? "days"
                                                                                : ""}
                                                                            </td>
                                                                            <td className="cancel-td">
                                                                              {+rCharge?.Value ===
                                                                              0 ? (
                                                                                "Non Chargeable"
                                                                              ) : +rCharge?.Value ===
                                                                                  100 &&
                                                                                rCharge?.ValueType ===
                                                                                  1 ? (
                                                                                "Non Refundable"
                                                                              ) : (
                                                                                <>
                                                                                  {rCharge?.ValueType ===
                                                                                  0
                                                                                    ? "₹ "
                                                                                    : ""}
                                                                                  {
                                                                                    rCharge?.Value
                                                                                  }
                                                                                  {rCharge?.ValueType ===
                                                                                  1
                                                                                    ? "%"
                                                                                    : ""}
                                                                                </>
                                                                              )}
                                                                            </td>
                                                                          </tr>
                                                                        );
                                                                      }
                                                                    )}
                                                                    <tr className="cancel-row">
                                                                      <td
                                                                        className="cancel-td"
                                                                        colSpan={
                                                                          5
                                                                        }
                                                                      >
                                                                        <strong className="d-block">
                                                                          *From
                                                                          the
                                                                          Time
                                                                          of
                                                                          Departure
                                                                        </strong>
                                                                        <strong>
                                                                          *Sevice
                                                                          charge
                                                                          will
                                                                          be
                                                                          extra
                                                                        </strong>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                              </div>
                                                            </div>
                                                          )}
                                                        </div>
                                                      )}
                                                      <div className="travel-detail-btns mt-4">
                                                        <a
                                                          className="btn disable"
                                                          href="javascript:void(0)"
                                                          data-bs-dismiss="modal"
                                                        >
                                                          Close
                                                        </a>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  );
                                }
                              )}
                              <div className="traveller-container">
                                <div className="traveller-header">
                                  <div className="column traveller-col">
                                    Traveller
                                  </div>
                                  <div className="column pnr-col">
                                    PNR/E-Ticket Number
                                  </div>
                                  <div className="column">Seat</div>
                                  <div className="column">Meal</div>
                                  <div className="column">Excess Baggage</div>
                                </div>

                                {tripInfo?.PAXTicketDetails?.filter(
                                  (e: any) =>
                                    e?.TicketStatus === "Tocancel" ||
                                    e?.TicketStatus === "Cancelled"
                                )?.map((pax: any, index: number) => (
                                  <div
                                    className={`traveller-row cancelled-traveller-row`}
                                    key={index}
                                  >
                                    <div className="column traveller-col">
                                      <img
                                        src={
                                          pax.Gender === 0
                                            ? MALE_ICON
                                            : FEMALE_ICON
                                        }
                                        alt="user"
                                      />
                                      <div className="traveller-name">
                                        <span>
                                          {`${pax.Title} ${pax.First_Name} ${pax.Last_Name}`}
                                        </span>
                                        <p className="cancelled-name">
                                          {`(${pax?.TicketStatus})`}
                                        </p>
                                      </div>
                                      <div className="traveller-details">
                                        &nbsp;
                                        {pax?.Pax_type === 0
                                          ? "Adult"
                                          : pax?.Pax_type === 1
                                          ? "Child"
                                          : "Infant"}
                                        , {pax.Gender === 0 ? "Male" : "Female"}
                                      </div>
                                    </div>
                                    <div className="column pnr pnr-col">
                                      <span>{tripInfo?.Airline_PNR}/</span>
                                      <span>
                                        {pax?.TicketDetails[0]?.Ticket_Number}
                                      </span>
                                    </div>
                                    <div className="column seat">
                                      {pax?.SSRDetails?.filter(
                                        (e: any) => e?.SSR_Type === 3
                                      )
                                        .map((e: any) => e?.SSR_Code)
                                        .filter(Boolean)
                                        .join(", ") || " - "}
                                    </div>
                                    {(() => {
                                      const meals =
                                        pax?.SSRDetails?.filter(
                                          (e: any) =>
                                            e?.SSR_Type === 1 ||
                                            e?.SSR_Type === 2
                                        ) || [];
                                      return meals.length === 1 ? (
                                        <div className="column meal">
                                          {meals[0]?.SSR_TypeDesc || " - "}
                                        </div>
                                      ) : meals.length > 1 ? (
                                        <div
                                          className="column multi-meal"
                                          {...(pax?.TicketStatus !==
                                            "Tocancel" &&
                                            pax?.TicketStatus !==
                                              "Cancelled" && {
                                              "data-bs-toggle": "modal",
                                              "data-bs-target": `#meal_${tripIndex}_${index}`,
                                            })}
                                        >
                                          {meals.length} Meals
                                        </div>
                                      ) : (
                                        <div className="column meal"> - </div>
                                      );
                                    })()}
                                    <div className="column baggage">
                                      {pax?.SSRDetails?.find(
                                        (e: any) => e?.SSR_Type === 0
                                      )?.SSR_TypeDesc || " - "}
                                    </div>
                                    <div
                                      className="modal fade"
                                      id={`meal_${tripIndex}_${index}`}
                                      data-bs-backdrop="static"
                                      data-bs-keyboard="false"
                                      tabIndex={-1}
                                      aria-labelledby="farerulepopup"
                                      aria-hidden="true"
                                    >
                                      <div
                                        className="modal-dialog modal-dialog-centered"
                                        style={{ maxWidth: 450 }}
                                      >
                                        <div className="modal-content">
                                          <div className="modal-header meal-modal-header">
                                            <h4
                                              className="modal-title fs-5"
                                              id="edit-profile"
                                            >
                                              {`${pax.Title} ${pax.First_Name} ${pax.Last_Name}'s Meals`}
                                            </h4>
                                            <button
                                              type="button"
                                              className="btn-close"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                          <div className="modal-body travel-form-detail">
                                            <ul className="meal-list">
                                              {pax?.SSRDetails?.filter(
                                                (e: any) =>
                                                  e?.SSR_Type === 1 ||
                                                  e?.SSR_Type === 2
                                              ).map((e: any) => (
                                                <li className="meal-item">
                                                  {e?.SSR_TypeDesc}
                                                </li>
                                              ))}
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </>
                          </div>
                        )}
                      </div>
                    );
                  })}
                <div className="info-card">
                  <div className="info-header">
                    <img src={MICSVG} alt="info-icon" />
                    <strong className="imp-info-title">
                      Important Information
                    </strong>
                  </div>
                  <div className="info-content">
                    <img src={RIGHTWCIRCLE} alt="tick" />
                    <span>
                      Carry a valid photo identification proof (Driver Licence,
                      Aadhar Card, Pan Card or any other Government recognised
                      photo identification)
                    </span>
                  </div>
                </div>
                <div className="contact-card">
                  <div
                    className="contact-header"
                    onClick={() => setContactOpen(!contactOpen)}
                  >
                    <div>
                      <strong className="imp-info-title">
                        Primary Contact
                      </strong>
                      <p>
                        We will contact you on this number. You can email or
                        whatsapp the ticket to other contacts
                      </p>
                    </div>
                    <TfiArrowCircleDown
                      className="me-2 chevron-icon"
                      style={{
                        transform: contactOpen
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    />
                  </div>
                  {contactOpen && (
                    <>
                      <hr />
                      <div className="contact-body">
                        <div className="contact-info">
                          <div className="info-item">
                            <img src={MAILICON} alt="email" />
                            <a href={`mailto:${BookingDetails?.PAX_EmailId}`}>
                              {BookingDetails?.PAX_EmailId}
                            </a>
                          </div>
                          <div className="info-item">
                            <img src={PHONEICON} alt="phone" />
                            <a href={`tel:+91${BookingDetails?.PAX_Mobile}`}>
                              {BookingDetails?.PAX_Mobile}
                            </a>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="col-lg-4 col-md-5 col-sm-12">
                <div className="ticket-card">
                  <h3 className="ticket-title">Ticket(s)</h3>
                  <ul className="ticket-list">
                    <li
                      className="position-relative"
                      onClick={
                        !isMultiPnr
                          ? () =>
                              !ticketLoading &&
                              handleDownloadPdf(
                                BookingDetails?.portal_booking_no,
                                BookingDetails?.AirPNRDetails &&
                                  BookingDetails?.AirPNRDetails[0]?.Airline_PNR,
                                0
                              )
                          : undefined
                      }
                      {...(isMultiPnr && {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#downloadticket_popup",
                      })}
                    >
                      <span className="icon">
                        {ticketLoading ? (
                          <div
                            className="spinner-border text-primary me-1"
                            role="status"
                            style={{ width: 15, height: 15 }}
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="20"
                            viewBox="0 0 24 24"
                            fill={"#007BFF"}
                          >
                            <path d="M0 0h24v24H0V0z" fill="none" />
                            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18h14v2H5z" />
                          </svg>
                        )}
                      </span>
                      <span
                        style={{
                          color: ticketLoading ? "#999999" : "#007BFF",
                        }}
                      >
                        Download E-Ticket(s)
                      </span>
                    </li>

                    <li
                      onClick={
                        !isMultiPnr
                          ? () =>
                              !invoiceLoading &&
                              handleDownloadInvoice(
                                BookingDetails?.portal_booking_no,
                                BookingDetails?.AirPNRDetails &&
                                  BookingDetails?.AirPNRDetails[0]?.Airline_PNR,
                                0
                              )
                          : undefined
                      }
                      {...(isMultiPnr && {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#downloadinvoice_popup",
                      })}
                    >
                      <span className="icon">
                        {invoiceLoading ? (
                          <div
                            className="spinner-border text-primary me-1"
                            role="status"
                            style={{ width: 15, height: 15 }}
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="20"
                            viewBox="0 0 24 24"
                            fill={"#007BFF"}
                          >
                            <path d="M0 0h24v24H0V0z" fill="none" />
                            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18h14v2H5z" />
                          </svg>
                        )}
                      </span>
                      <span
                        style={{
                          color: invoiceLoading ? "#999999" : "#007BFF",
                        }}
                      >
                        Download Invoice(s)
                      </span>
                    </li>
                    <li
                      onClick={() => {
                        if (!CNLoading) {
                          handleCreditNoteClick(
                            BookingDetails?.portal_booking_no
                          );
                        }
                      }}
                    >
                      <span className="icon">
                        {CNLoading ? (
                          <div
                            className="spinner-border text-primary me-1"
                            role="status"
                            style={{ width: 15, height: 15 }}
                          >
                            <span className="sr-only"></span>
                          </div>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="20"
                            viewBox="0 0 24 24"
                            fill={"#007BFF"}
                          >
                            <path d="M0 0h24v24H0V0z" fill="none" />
                            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18h14v2H5z" />
                          </svg>
                        )}
                      </span>
                      <span
                        style={{
                          color: CNLoading ? "#999999" : "#007BFF",
                        }}
                      >
                        Credit Note(s)
                      </span>
                    </li>
                  </ul>
                </div>
                <div className="price-card">
                  <h3 className="price-title m-0 border-bottom">
                    Price Breakup
                  </h3>
                  <p className="border-bottom">
                    <span className="price-smry-title">Airline Base Fare</span>
                    <strong className="price-smry-amount">
                      {BookingDetails &&
                        `₹ ${formatIndianNumber(
                          (faredetails?.adults?.basic || 0) +
                            (faredetails?.children?.basic || 0) +
                            (faredetails?.infants?.basic || 0)
                        )}`}
                    </strong>
                  </p>
                  <p className="border-bottom">
                    <span className="price-smry-title">Taxes & Fees</span>
                    <strong className="price-smry-amount">
                      {BookingDetails &&
                        `₹ ${formatIndianNumber(
                          (faredetails?.adults?.taxes || 0) +
                            (faredetails?.children?.taxes || 0) +
                            (faredetails?.infants?.taxes || 0)
                          // (faredetails?.overall?.serviceAmount || 0)
                        )}`}
                    </strong>
                  </p>
                  {BookingDetails?.convenience_fee > 0 && (
                    <p className="border-bottom">
                      <span className="price-smry-title">Convenience Fee</span>
                      <strong className="price-smry-amount">
                        {BookingDetails &&
                          `₹ ${formatIndianNumber(
                            BookingDetails?.convenience_fee
                          )}`}
                      </strong>
                    </p>
                  )}
                  <p className="border-bottom">
                    <strong className="price-smry-amount">Total Amount</strong>
                    <strong className="price-smry-amount">
                      {BookingDetails &&
                        `₹ ${formatIndianNumber(
                          (faredetails?.adults?.total || 0) +
                            (faredetails?.children?.total || 0) +
                            (faredetails?.infants?.total || 0) +
                            (BookingDetails?.convenience_fee || 0)
                        )}`}
                    </strong>
                  </p>
                  {BookingDetails?.PromoCodeValue > 0 && (
                    <p className="border-bottom" style={{ color: "#00a34d" }}>
                      <span className="price-smry-title">
                        PromoCode ({BookingDetails?.PromoCode})
                      </span>
                      <strong className="price-smry-amount">
                        {BookingDetails &&
                          `- ₹ ${formatIndianNumber(
                            BookingDetails?.PromoCodeValue
                          )}`}
                      </strong>
                    </p>
                  )}
                  {BookingDetails?.GiftCodeValue > 0 && (
                    <p className="border-bottom" style={{ color: "#00a34d" }}>
                      <span className="price-smry-title">
                        GiftCode ({BookingDetails?.GiftCode})
                      </span>
                      <strong className="price-smry-amount">
                        {BookingDetails &&
                          `- ₹ ${formatIndianNumber(
                            BookingDetails?.GiftCodeValue
                          )}`}
                      </strong>
                    </p>
                  )}
                  {BookingDetails?.wallet_balance > 0 && (
                    <p className="border-bottom" style={{ color: "#00a34d" }}>
                      <span className="price-smry-title">
                        Used Wallet Amount
                      </span>
                      <strong className="price-smry-amount">
                        {BookingDetails &&
                          `- ₹ ${formatIndianNumber(
                            BookingDetails?.wallet_balance
                          )}`}
                      </strong>
                    </p>
                  )}
                  {BookingDetails?.CreditLimitUsedAmount > 0 && (
                    <p className="border-bottom" style={{ color: "#00a34d" }}>
                      <span className="price-smry-title">
                        Used Credit Limit
                      </span>
                      <strong className="price-smry-amount">
                        {BookingDetails &&
                          `- ₹ ${formatIndianNumber(
                            BookingDetails?.CreditLimitUsedAmount
                          )}`}
                      </strong>
                    </p>
                  )}
                  <p>
                    <strong className="price-smry-amount">Paid Amount</strong>
                    <strong className="price-smry-amount">
                      {BookingDetails &&
                        `₹ ${formatIndianNumber(
                          (faredetails?.adults?.total || 0) +
                            (faredetails?.children?.total || 0) +
                            (faredetails?.infants?.total || 0) +
                            (BookingDetails?.convenience_fee || 0) -
                            (BookingDetails?.PromoCodeValue || 0) -
                            (BookingDetails?.GiftCodeValue || 0) -
                            (BookingDetails?.wallet_balance || 0) -
                            (BookingDetails?.CreditLimitUsedAmount || 0)
                        )}`}
                    </strong>
                  </p>
                </div>
                {BookingDetails?.PaymentMode && (
                  <div className="price-card">
                    <p className="amount-paid-header">
                      <strong className="price-smry-amount">Amount Paid</strong>
                      <strong className="price-smry-amount">
                        {BookingDetails &&
                          `₹ ${formatIndianNumber(
                            (faredetails?.adults?.total || 0) +
                              (faredetails?.children?.total || 0) +
                              (faredetails?.infants?.total || 0) +
                              (BookingDetails?.convenience_fee || 0) -
                              (BookingDetails?.PromoCodeValue || 0) -
                              (BookingDetails?.GiftCodeValue || 0) -
                              (BookingDetails?.wallet_balance || 0) -
                              (BookingDetails?.CreditLimitUsedAmount || 0)
                          )}`}
                      </strong>
                    </p>
                    <p>
                      <strong>{BookingDetails?.PaymentMode}</strong>
                      <strong>
                        {BookingDetails &&
                          `₹ ${formatIndianNumber(
                            (faredetails?.adults?.total || 0) +
                              (faredetails?.children?.total || 0) +
                              (faredetails?.infants?.total || 0) +
                              (BookingDetails?.convenience_fee || 0) -
                              (BookingDetails?.PromoCodeValue || 0) -
                              (BookingDetails?.GiftCodeValue || 0) -
                              (BookingDetails?.wallet_balance || 0) -
                              (BookingDetails?.CreditLimitUsedAmount || 0)
                          )}`}
                      </strong>
                    </p>
                  </div>
                )}
                <div
                  className="modal fade"
                  id={`downloadticket_popup`}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex={-1}
                  aria-labelledby="downloadticket-popup"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    style={{ maxWidth: 500 }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title fs-5" id="edit-profile">
                          Download E-Ticket(s)
                        </h4>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body mt-2">
                        {BookingDetails &&
                          BookingDetails?.AirPNRDetails?.map(
                            (tripInfo: any, tripIndex: any) => {
                              return (
                                <div className="invoice-card">
                                  <div className="icon">
                                    <BsFillFileEarmarkPdfFill />
                                  </div>
                                  <div className="info">
                                    <div className="title">
                                      {
                                        tripInfo?.Flights[0]?.Segments[0]
                                          ?.Origin
                                      }{" "}
                                      →{" "}
                                      {
                                        tripInfo?.Flights[0]?.Segments[
                                          tripInfo?.Flights[0]?.Segments
                                            ?.length - 1
                                        ]?.Destination
                                      }
                                    </div>
                                    <div className="date">
                                      {moment(
                                        tripInfo?.Flights[0]?.Segments[0]
                                          ?.Departure_DateTime,
                                        "MM/DD/YYYY HH:mm:ss"
                                      ).format("D MMMM")}
                                      ,{" "}
                                      {
                                        tripInfo?.Flights[0]?.Segments[0]
                                          ?.Airline_Name
                                      }
                                    </div>
                                  </div>
                                  <div className="download">
                                    {ticketLoadingIndexes?.includes(
                                      tripIndex
                                    ) ? (
                                      <div
                                        className="spinner-border text-primary ticket-pop-loading"
                                        role="status"
                                      />
                                    ) : (
                                      <HiDownload
                                        style={{ fontSize: 22 }}
                                        onClick={() => {
                                          !ticketLoadingIndexes?.includes(
                                            tripIndex
                                          ) &&
                                            handleDownloadPdf(
                                              BookingDetails?.portal_booking_no,
                                              tripInfo?.Airline_PNR,
                                              tripIndex
                                            );
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        <div className="download-all">
                          <button
                            className="download-btn"
                            onClick={async () => {
                              if (
                                !BookingDetails ||
                                !BookingDetails.AirPNRDetails
                              )
                                return;

                              try {
                                await Promise.all(
                                  BookingDetails.AirPNRDetails.map(
                                    (tripInfo: any, tripIndex: number) =>
                                      handleDownloadPdf(
                                        BookingDetails?.portal_booking_no,
                                        tripInfo?.Airline_PNR,
                                        tripIndex
                                      ).catch((err) => {
                                        console.error(
                                          `Download failed for trip ${tripIndex}`,
                                          err
                                        );
                                      })
                                  )
                                );
                              } catch (err) {
                                console.error(
                                  "Error downloading all tickets",
                                  err
                                );
                              }
                            }}
                          >
                            Download All Tickets
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal fade"
                  id={`downloadinvoice_popup`}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex={-1}
                  aria-labelledby="downloadticket-popup"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    style={{ maxWidth: 500 }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title fs-5">
                          Download Invoice(s)
                        </h4>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="modal-body mt-2">
                        {BookingDetails &&
                          BookingDetails?.AirPNRDetails?.map(
                            (tripInfo: any, tripIndex: any) => {
                              return (
                                <div className="invoice-card">
                                  <div className="icon invoice">
                                    <BsFillFileTextFill />
                                  </div>
                                  <div className="info">
                                    <div className="title">
                                      {
                                        tripInfo?.Flights[0]?.Segments[0]
                                          ?.Origin
                                      }{" "}
                                      →{" "}
                                      {
                                        tripInfo?.Flights[0]?.Segments[
                                          tripInfo?.Flights[0]?.Segments
                                            ?.length - 1
                                        ]?.Destination
                                      }
                                    </div>
                                    <div className="date">
                                      {moment(
                                        tripInfo?.Flights[0]?.Segments[0]
                                          ?.Departure_DateTime,
                                        "MM/DD/YYYY HH:mm:ss"
                                      ).format("D MMMM")}
                                      ,{" "}
                                      {
                                        tripInfo?.Flights[0]?.Segments[0]
                                          ?.Airline_Name
                                      }
                                    </div>
                                  </div>
                                  <div className="download">
                                    {invoiceLoadingIndexes?.includes(
                                      tripIndex
                                    ) ? (
                                      <div
                                        className="spinner-border text-primary ticket-pop-loading"
                                        role="status"
                                      />
                                    ) : (
                                      <HiDownload
                                        style={{ fontSize: 22 }}
                                        onClick={() => {
                                          !invoiceLoadingIndexes?.includes(
                                            tripIndex
                                          ) &&
                                            handleDownloadInvoice(
                                              BookingDetails?.portal_booking_no,
                                              tripInfo?.Airline_PNR,
                                              tripIndex
                                            );
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        <div className="download-all">
                          <button
                            className="download-btn"
                            onClick={async () => {
                              if (
                                !BookingDetails ||
                                !BookingDetails.AirPNRDetails
                              )
                                return;

                              try {
                                await Promise.all(
                                  BookingDetails.AirPNRDetails.map(
                                    (tripInfo: any, tripIndex: number) =>
                                      handleDownloadInvoice(
                                        BookingDetails?.portal_booking_no,
                                        tripInfo?.Airline_PNR,
                                        tripIndex
                                      ).catch((err) => {
                                        console.error(
                                          `Download failed for trip ${tripIndex}`,
                                          err
                                        );
                                      })
                                  )
                                );
                              } catch (err) {
                                console.error(
                                  "Error downloading all Invoices",
                                  err
                                );
                              }
                            }}
                          >
                            Download All Invoices
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Modal
                  isOpen={isCNModalOpen}
                  onClose={() => setIsCNModalOpen(false)}
                  title="Credit Note(s)"
                >
                  {CNList && CNList.length > 0 ? (
                    <>
                      {CNList.map((note: any, index: number) => (
                        <div className="invoice-card" key={index}>
                          <div className="icon invoice">
                            <BsFillFileTextFill />
                          </div>
                          <div className="info">
                            <div className="title">{note?.creditnote_no}</div>
                            <div className="date">
                              {note?.createdon
                                ? moment(
                                    note.createdon,
                                    "DD/MM/YYYY HH:mm:ss"
                                  ).format("D MMMM YYYY")
                                : "Date not available"}
                            </div>
                          </div>
                          <div className="download">
                            {CNLoadingIndexes?.includes(index) ? (
                              <div
                                className="spinner-border text-primary ticket-pop-loading"
                                role="status"
                              />
                            ) : (
                              <HiDownload
                                style={{ fontSize: 22 }}
                                onClick={() => {
                                  !CNLoadingIndexes?.includes(index) &&
                                    handleDownloadCN(
                                      note?.portal_booking_no,
                                      note?.creditnote_no,
                                      index
                                    );
                                }}
                              />
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="download-all">
                        <button
                          className="download-btn"
                          onClick={async () => {
                            try {
                              await Promise.all(
                                CNList.map((CreditNote: any, index: number) =>
                                  handleDownloadCN(
                                    CreditNote?.portal_booking_no,
                                    CreditNote?.creditnote_no,
                                    index
                                  ).catch((err) => {
                                    console.error(
                                      `Download failed for trip ${index}`,
                                      err
                                    );
                                  })
                                )
                              );
                            } catch (err) {
                              console.error(
                                "Error downloading all Credit notes",
                                err
                              );
                            }
                          }}
                        >
                          Download All Credit Notes
                        </button>
                      </div>
                    </>
                  ) : (
                    <p>No credit notes available.</p>
                  )}
                </Modal>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CancelledTripDetails;
